import React, { useState, useEffect } from "react";
import { Alert, Button, FormControl, Modal, Form } from "react-bootstrap";
import Header from "../Dashboard/Header";
import DataTable from "react-data-table-component";
import Loader from "../common/spinner";

import {
  SendImage,
  deleteAppointment,
  getAllAppointments,
  update,
} from "../APIs/api-routes.util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrash, fas } from "@fortawesome/free-solid-svg-icons";
import { isMobile } from "react-device-detect";
import html2canvas from "html2canvas";
import moment from "moment";
import DatePicker from "react-datepicker";

function AllAppointments() {
  const columns = [
    {
      name: "Token Number",
      selector: (row: any) => <div className="alert alert-danger">{row.token_number}</div>,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row: any) => row.Date,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row: any) => row.Name,
      sortable: true,
    },
    {
      name: "Guardian Name",
      selector: (row: any) => row.GuardianName,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row: any) => row.Phone,
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row: any) => (
        <div style={{ 
          display: "flex", 
          gap: isMobile ? "10px" : "20px",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <FontAwesomeIcon
            style={{ 
              color: "red", 
              cursor: "pointer",
              fontSize: isMobile ? "16px" : "18px"
            }}
            onClick={() => {
              setId(row.ID);
              setShowModel(true);
              setOrigin("delete");
            }}
            icon={faTrash}
          />
          <FontAwesomeIcon
            style={{ 
              color: "green", 
              cursor: "pointer",
              fontSize: isMobile ? "16px" : "18px"
            }}
            onClick={() => {
              setId(row.ID);
              setShowModel(true);
              setOrigin("edit");
              setEditedData({
                ...editedData,
                date: row.Date,
                phone: row.Phone,
                name: row.Name,
                guardianName: row.GuardianName,
              });
            }}
            icon={faPencil}
          />
        </div>
      ),
      sortable: true,
    },
  ];
  const column = [
    {
      name: "Token Number",
      selector: (row: any) => row.token_number,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row: any) => row.Date,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row: any) => row.Name,
      sortable: true,
    },
    {
      name: "Guardian Name",
      selector: (row: any) => row.GuardianName,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row: any) => row.Phone,
      sortable: true,
    },
  ];
  interface Appointment {
    Date: string;
    Name: string;
    GuardianName: string;
    Phone: string;
    ID: number;
    token_number:number
  }

  const [data, setData] = useState<Appointment[]>([]);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [id, setId] = useState("");
  const [origin, setOrigin] = useState("");
  const [genImage, SetGenImage] = useState(false);
  const [editedData, setEditedData] = useState({
    phone: "",
    date: "",
    name: "",
    guardianName: "",
    token_number: "",
  });

  const [show, setShow] = useState({
    loader: false,
  });
  const [showMessage, setShowMessage] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [showImgModel, setShowImgModel] = useState(false);
  const [date, setDate] = useState<any>(new Date());

  const [filterText, setFilterText] = React.useState<any>();
  const [canvasDataURL, setCanvasDataURL] = useState<string | null>(null); // State to store the captured image

  const deleteAPointment = (id: any) => {
    setShow({ ...show, loader: true });
    deleteAppointment(id).subscribe((res: any) => {
      // Always refresh the list regardless of response
     
    });

    setTimeout(() => {
      getAll();
      
      setMessage("Appointment deleted successfully");
      setSuccess(true);
      
      setShowModel(false);
      setShowMessage(true);
      setShow({ ...show, loader: false });
    }, 1000);
  };
  const currentDate = new Date();

  const handleCloseModal = () => {
    setShowModel(false);
  };
  const handleConfirm = () => {
    setShowModel(false);
    deleteAPointment(id);
  };
  const sendImg = () => {
    setShow({ ...show, loader: true });
    // if (canvasDataURL) {
      SendImage(canvasDataURL).subscribe((res: any) => {
        setShow({ ...show, loader: false });
        if ("response" in res && res.response?.status) {
          setMessage(res.response?.status);
          setSuccess(true);
          setShowMessage(true)
          setShow({ ...show, loader: false });
        } else {
          setSuccess(false);
          setShowMessage(true)
          setMessage("Something went wrong");
          setOrigin("danger");
          setShow({ ...show, loader: false });
        }
      });
    // } else {
    //   setShow({ ...show, loader: false });
    //   setOrigin("danger");
    //   setMessage("Image is not available");
    // }
  };
  const containerRef = React.useRef(null);

  const todaty = currentDate.toISOString().split("T")[0];
  const getAll = () =>{
    getAllAppointments(moment(date).format("YYYY-MM-DD")).subscribe(
      (res: any) => {
        setShow({ ...show, loader: false });
        if ("response" in res && res.response) {
          const response = res.response;
          setData(response);
          setSuccess(true);
        } else {
          setMessage("Something went wrong");
          setShowMessage(true);
        }
      },
      (error) => {
        setMessage("An error occurred while fetching data");
        setShowMessage(true);
      }
    );
  }
  useEffect(() => {
    setShow({ ...show, loader: true });
    getAll();
    setFilterText(todaty);
  }, [todaty, date]);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    setShow({ ...show, loader: true });
    update(id, editedData).subscribe((res: any) => {
      if (res.response?.appointment) {
        setSuccess(true);
        const appointment = res.response?.appointment;
        data?.map((item) => {
          if (item.ID === appointment.ID) {
            item.Date = appointment.Date;
            item.Phone = appointment.Phone;
            item.Name = appointment.Name;
            item.GuardianName = appointment.GuardianName;
          }
          return item;
        });
      }
      setShowModel(false);
      setMessage(res.response.message);
      setShowMessage(true);
      setShow({ ...show, loader: false });
    });
  };

  //------------------------------

  const generateImage = () => {
    const captureElement:any = document.getElementById("capture");
    if (captureElement) {
      // Temporarily adjust the element's style for full visibility
      captureElement.style.display = "flex";
      captureElement.style.maxWidth = "none";
      captureElement.style.width = "auto";
    }
  
    // Ensure the element is fully visible in the viewport
    captureElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  

    const input = document.getElementById("capture");
    if (input) {
      html2canvas(input, { useCORS: true })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          setCanvasDataURL(imgData);

          const link = document.createElement("a");
          link.href = imgData;
          link.download = "table.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          if (captureElement) {
            captureElement.style.display = "none";
          }
        })
        .catch((error) => {
          console.error("Something went wrong:", error);
        });
    }
  };
   
    const jsonToImg = ( ) => {
      if (containerRef.current) {
        html2canvas(containerRef.current, {scrollY: -window.scrollY}).then(canvas => {
          const image = canvas.toDataURL('image/png');
          const downloadLink = document.createElement('a');
          downloadLink.href = image;
          downloadLink.download = `${moment().format("dddd-DD-MM-YYYY")}.png`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        });
      }
      setShowImgModel(false);
    };
React.useEffect(() => { if(genImage) { jsonToImg(); SetGenImage(false) } }, [genImage]);

  //--------------------------------------------------------

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <div style={{ 
        width: "100%", 
        display: "flex", 
        gap: isMobile ? "5px" : "10px",
        flexWrap: isMobile ? "wrap" : "nowrap",
        flexDirection: isMobile ? "column" : "row"
      }}>
        <div style={{ 
          display: "flex", 
          gap: isMobile ? "5px" : "10px",
          width: isMobile ? "100%" : "auto",
          flexWrap: isMobile ? "wrap" : "nowrap"
        }}>
          <Button 
            style={{ 
              width: isMobile ? "48%" : "30%",
              fontSize: isMobile ? "12px" : "14px",
              padding: isMobile ? "8px 4px" : "10px 16px"
            }} 
            onClick={generateImage}
          >
            {isMobile ? "Desktop Image" : "Download Image Desktop"}
          </Button>
          <Button
            style={{ 
              width: isMobile ? "48%" : "30%",
              fontSize: isMobile ? "12px" : "14px",
              padding: isMobile ? "8px 4px" : "10px 16px"
            }}
            onClick={() => {
              setShowImgModel(true);
              SetGenImage(true);
            }}
          >
            {isMobile ? "Mobile Image" : "Download Image Mobile"}
          </Button>
        </div>
        <div style={{ 
          width: isMobile ? "100%" : "auto",
          marginTop: isMobile ? "10px" : "0px"
        }}>
          <DatePicker
            showIcon
            selected={date}
            onChange={(date) => setDate(date)}
            wrapperClassName={isMobile ? "w-100" : ""}
          />
        </div>
      </div>
    );
  }, [filterText, date, isMobile]);

  return (
    <>
      <Loader show={show.loader} />
      <Header />
      <div className="main-container">
        <div
          style={isMobile ? { width: "95%" } : { width: "600px" }}
          className="alert-div"
        >
          <Alert
            variant={success ? "success" : "danger"}
            show={showMessage}
            onClose={() => setShowMessage(false)}
            dismissible
          >
            {message}
          </Alert>
        </div>

        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "column",
          }}
        >
          <div style={{ width: "100%" }} className="printable-section">
            <DataTable
              fixedHeader
              responsive
              theme="solarized"
              subHeader={true}
              data={data}
              // selectableRows={true}
              // selectableRowsHighlight={true}
              fixedHeaderScrollHeight={isMobile ? "calc(100vh - 250px)" : "calc(100vh - 195px)"}
              columns={columns}
              // onSelectedRowsChange={selectedrow}
              subHeaderComponent={subHeaderComponentMemo}
            />
          </div>
        </div>
      </div>
      <div id="capture" style={{ display: "none", width: "50%" }}>
        <DataTable responsive data={data} columns={column} />
      </div>

      <Modal show={showModel} onHide={handleCloseModal}>
        {origin === "edit" && (
          <Modal.Header>
            <h5>Edit Appointment</h5>
          </Modal.Header>
        )}

        <Modal.Body>
          {origin === "edit" ? (
            <Form onSubmit={handleSubmit}>
              <Form.Group
                style={{
                  width: "100%",
                }}
                className="mb-3"
              >
                <Form.Label>Date</Form.Label>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Form.Control
                    type="date"
                    placeholder="Check available day"
                    aria-label="Check available day"
                    aria-describedby="basic-addon2"
                    value={editedData.date}
                    onChange={(e) => {
                      setEditedData({
                        ...editedData,
                        date: e.target.value,
                      });
                    }}
                  />
                  <Button
                    // onClick={checkDate}
                    variant="outline-secondary"
                    id="button-addon2"
                  >
                    Check
                  </Button>
                </div>
              </Form.Group>
              <Form.Group
                style={{
                  width: "100%",
                }}
                className="mb-3"
              >
                <Form.Label>phone</Form.Label>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Form.Control
                    type="text"
                    placeholder="Check Booked Appointments on phone NO"
                    aria-label="Check Booked Appointments on phone NO"
                    aria-describedby="basic-addon2"
                    value={editedData.phone}
                    onChange={(e) => {
                      setEditedData({
                        ...editedData,
                        phone: e.target.value,
                      });
                    }}
                  />
                </div>
              </Form.Group>

              <>
                <Form.Group
                  style={{
                    width: "100%",
                  }}
                  className="mb-3"
                >
                  <Form.Label>Full Name</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Enter Name"
                    aria-label="Enter Name"
                    value={editedData?.name}
                    aria-describedby="basic-addon2"
                    onChange={(e) => {
                      setEditedData({
                        ...editedData,
                        name: e.target.value,
                      });
                    }}
                  />
                </Form.Group>
                <Form.Group
                  style={{
                    width: "100%",
                  }}
                  className="mb-3"
                >
                  <Form.Label>Guardian Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Guardian Name"
                    aria-label="Enter Guardian Name"
                    aria-describedby="basic-addon2"
                    value={editedData?.guardianName}
                    onChange={(e) => {
                      setEditedData({
                        ...editedData,
                        guardianName: e.target.value,
                      });
                    }}
                  />
                </Form.Group>
              </>
            </Form>
          ) : (
            <h5>Are you sure you want to delete this appointment ?</h5>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant={origin === "edit" ? "success" : "danger"}
            onClick={origin === "edit" ? handleSubmit : handleConfirm}
          >
            {origin === "edit" ? "Update" : "Confirm"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showImgModel} onHide={handleCloseModal}>
        {origin === "edit" && (
          <Modal.Header>
            <h5>Edit Appointment</h5>
          </Modal.Header>
        )}

        <Modal.Body>
        <div>
      <div ref={containerRef} style={{overflowX: 'auto'}}>
        <div style={{border:'1px solid gray'}}><strong>Date</strong>: &nbsp;<span>{data[0]?.Date}</span></div>
        <table style={{borderCollapse: 'collapse', width: '100%',fontSize: '12px'}}>
          <thead>
            <tr>
              {/* <th style={{border: '1px solid #ccc', padding: '2px'}}>Date</th> */}
              <th style={{border: '1px solid #ccc', padding: '2px'}}>Token No</th>
              <th style={{border: '1px solid #ccc', padding: '2px'}}>Name</th>
              <th style={{border: '1px solid #ccc', padding: '2px'}}>Guardian</th>
              <th style={{border: '1px solid #ccc', padding: '2px'}}>Phone</th>
            </tr>
          </thead>
          <tbody>
            {data.map((data, index) => (
              <tr key={index}>
                {/* <td style={{border: '1px solid #ccc', padding: '2px'}}>{data.Date}</td> */}
                <td style={{border: '1px solid #ccc', padding: '2px'}}>{data?.token_number}</td>
                <td style={{border: '1px solid #ccc', padding: '2px'}}>{data.Name}</td>
                <td style={{border: '1px solid #ccc', padding: '2px'}}>{data.GuardianName}</td>
                <td style={{border: '1px solid #ccc', padding: '2px'}}>{data.Phone}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button onClick={jsonToImg} style={{margin: '10px 0'}}>Generate Table Image</button>
    </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={()=>{setShowImgModel(false)}}>
            Cancel
          </Button>
          {/* <Button
            variant={origin === "edit" ? "success" : "danger"}
            onClick={origin === "edit" ? handleSubmit : handleConfirm}
          >
            {origin === "edit" ? "Update" : "Confirm"}
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AllAppointments;
